(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-qmax-interactive"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('tt-qmax-demo')) return;
  class TTQmaxDemo extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const start = () => { if (this.isConnected) this.init(); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true, signal:this.abort.signal});
      else queueMicrotask(start);
    }
    disconnectedCallback() { this.abort?.abort(); }
    init() {
      this.range = this.querySelector('[data-q-range]');
      this.points = [...this.querySelectorAll('[data-q-point]')];
      if (!this.range || this.points.length !== 4) return;
      const options = {signal:this.abort.signal};
      this.range.addEventListener('input', () => this.update(this.range.value), options);
      this.points.forEach(button => button.addEventListener('click', () => {
        this.range.value = button.dataset.value;
        this.update(this.range.value);
      }, options));
      this.update(this.range.value);
      this.setAttribute('data-ready', '');
    }
    update(raw) {
      const parsed = Number(raw);
      const value = Math.min(.43, Math.max(.10, Number.isFinite(parsed) ? parsed : .10));
      const progress = (value - .10) / .33;
      const stops = [.10, .15, .25, .43];
      const nearest = stops.reduce((best, stop, index) => Math.abs(stop - value) < Math.abs(stops[best] - value) ? index : best, 0);
      const point = this.points[nearest];
      const colour = (hex, fallback) => {
        const match = /^#([0-9a-f]{6})$/i.exec(hex || '');
        return (match ? match[1] : fallback).match(/../g).map(x => parseInt(x,16));
      };
      const warm = colour(this.dataset.warm, 'be2220');
      const cool = colour(this.dataset.cool, '1972b9');
      const rgb = warm.map((x,i) => Math.round(x+(cool[i]-x)*progress));
      this.style.setProperty('--qx-progress', progress.toFixed(5));
      this.style.setProperty('--qx-percent', `${(progress*100).toFixed(3)}%`);
      this.style.setProperty('--qx-current', `rgb(${rgb.join(',')})`);
      this.querySelector('[data-q-value]').textContent = value.toFixed(2);
      this.querySelector('[data-q-title]').textContent = point.dataset.title;
      this.querySelector('[data-q-description]').textContent = point.dataset.description;
      this.querySelector('[data-q-strength]').textContent = point.dataset.strength;
      this.range.setAttribute('aria-valuetext', `${value.toFixed(2)} Qmax — ${point.dataset.title}`);
      this.points.forEach(button => button.setAttribute('aria-pressed', String(Math.abs(Number(button.dataset.value)-value)<.00001)));
    }
  }
  customElements.define('tt-qmax-demo', TTQmaxDemo);
})();


  } catch(e) { console.error(e); }
})();
})();
